import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface UserCollectionItem {
    readonly id: number;
    readonly firstName: string;
    readonly lastName: string;
    readonly role: 'Użytkownik' | 'Administrator';
}

export class UserCollectionQuery extends Query<UserCollectionItem[]> { }

export class UserCollectionQueryHandlerBase implements QueryHandler<UserCollectionQuery, UserCollectionItem[]> {
    public static Url = TaggedUrl.join('myCompany/users', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: UserCollectionQuery): Promise<UserCollectionItem[]> {
        const { data } = await this.http.get<{ items: UserCollectionItem[] }>(UserCollectionQueryHandlerBase.Url);
        return data.items;
    }
}
